import { useDefaultInheritance, useInheritance } from './inheritance';

export const useCanSetInheritance = () => {
    const defaultInheritance = useDefaultInheritance();
    const inheritance = useInheritance();

    const canSet = defaultInheritance !== inheritance;

    return canSet;
};
